import { OrderedMap } from 'immutable';

export const fontSizes = OrderedMap({
  Default: 0,
  Small: 10,
  Medium: 14,
  Large: 18,
  'X-Large': 30,
});
